import { Box, Flex } from "@chakra-ui/layout";
import { Radio, RadioGroup, RadioProps } from "@chakra-ui/react";
import { Col, Row } from "antd";
import {
  FormaDistribuicaoArrecadacaoEnum,
  TipoArrecadacaoEnum,
} from "features/arrecadacoes/enums";
import Field from "components/Input/Field";
import InputMoney from "components/Input/InputMoney";
import { FormArrecadacaoChildrenFormProps } from "./FormArrecadacao";
import { TitleWrapper } from "./TitleWrapper";

export function shouldShowValorInput(tipoArrecadacaoId: TipoArrecadacaoEnum) {
  const showValorInputTiposArrecadacao = [
    TipoArrecadacaoEnum.ValorIgualTodasUnidades,
    TipoArrecadacaoEnum.ValorPorIndexador,
    TipoArrecadacaoEnum.ValorTotalRateado,
    TipoArrecadacaoEnum.ValorMetrosUnidade,
  ];

  return showValorInputTiposArrecadacao.includes(tipoArrecadacaoId);
}

const StyledRadio = (props: RadioProps) => <Radio mb={4} {...props} />;

function FormValor({
  control,
  watch,
  current,
}: FormArrecadacaoChildrenFormProps) {
  const tipoArrecadacaoId = watch("tipoArrecadacaoId");

  const formaDistribuicaoArrecadacaoId = watch(
    "formaDistribuicaoArrecadacaoId"
  );

  const showValorInput =
    formaDistribuicaoArrecadacaoId ===
      FormaDistribuicaoArrecadacaoEnum.UnicaUnidade ||
    shouldShowValorInput(tipoArrecadacaoId as TipoArrecadacaoEnum);

  const isGrupo =
    formaDistribuicaoArrecadacaoId ===
    FormaDistribuicaoArrecadacaoEnum.GrupoUnidades;

  const isUnidadeUnica =
    formaDistribuicaoArrecadacaoId ===
    FormaDistribuicaoArrecadacaoEnum.UnicaUnidade;

  return (
    <Flex
      display={current ? undefined : "none"}
      flexDir="column"
      flex={1}
      w="100%"
    >
      <TitleWrapper>Qual valor será arrecadado?*</TitleWrapper>

      <Box as={Row} mb={4}>
        <Col sm={24}>
          <Field
            shouldUnregister
            control={control}
            name="tipoArrecadacaoId"
            rules={{
              required: current,
            }}
            render={({ field, isInvalid }) => (
              <RadioGroup
                w="fit-content"
                display="flex"
                flexDir="column"
                value={field.value}
                onChange={field.onChange}
              >
                <StyledRadio
                  isInvalid={isInvalid}
                  value={TipoArrecadacaoEnum.ValorIgualTodasUnidades}
                >
                  Igual para todas as unidades do{" "}
                  {isGrupo ? "grupo" : "condomínio"}
                </StyledRadio>
                <StyledRadio
                  isInvalid={isInvalid}
                  value={TipoArrecadacaoEnum.ValorObtidoRateioDespesa}
                >
                  Do rateio de despesas
                </StyledRadio>

                <>
                  <StyledRadio
                    isInvalid={isInvalid}
                    value={TipoArrecadacaoEnum.DespesaMesAnterior}
                  >
                    Total de despesas do mês anterior
                  </StyledRadio>
                  <StyledRadio
                    isInvalid={isInvalid}
                    value={TipoArrecadacaoEnum.ValorPorIndexador}
                  >
                    Varia de acordo com um peso
                  </StyledRadio>
                  <StyledRadio
                    isInvalid={isInvalid}
                    value={TipoArrecadacaoEnum.ValorDiferenteCadaUnidade}
                    isDisabled={isUnidadeUnica}
                  >
                    Diferente para cada unidade
                  </StyledRadio>
                </>

                <>
                  <StyledRadio
                    isInvalid={isInvalid}
                    value={TipoArrecadacaoEnum.ValorTotalRateado}
                    isDisabled={isUnidadeUnica}
                  >
                    Um total a ser rateado
                  </StyledRadio>
                  <StyledRadio
                    isInvalid={isInvalid}
                    value={TipoArrecadacaoEnum.ValorMetrosUnidade}
                  >
                    Para cada M² da unidade
                  </StyledRadio>
                </>
              </RadioGroup>
            )}
          />
        </Col>
      </Box>

      {showValorInput ? (
        <Box as={Row} mb={4}>
          <Col sm={6}>
            <Field
              shouldUnregister
              control={control}
              name="valor"
              label="Valor"
              rules={{
                required: current,
              }}
              render={({ field, isInvalid }) => (
                <InputMoney
                  decimalScale={3}
                  decimalsLimit={3}
                  isInvalid={isInvalid}
                  {...field}
                />
              )}
            />
          </Col>
        </Box>
      ) : null}
    </Flex>
  );
}

export default FormValor;
